import { render, staticRenderFns } from "./RelatorioLogUsuario.vue?vue&type=template&id=bafca052"
import script from "./RelatorioLogUsuario.vue?vue&type=script&lang=js"
export * from "./RelatorioLogUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports